module.exports = __webpack_public_path__ + "img/category-favorite.514385f7.png";